import { Box, Stack } from '@n26/nxd'
import { SectionWrapper } from './SectionWrapper'
import { SmallArticleCard } from './SmallArticleCard'
import { PopularSectionHero } from './PopularSectionHero'
import { useLocaliseString } from '@hooks/useLocaliseString'
import { type BlogPostCardProps } from '@components/BlogPostCard'

export type PopularSectionProps = {
  articles: BlogPostCardProps['post'][]
}

export const PopularSection = ({ articles }: PopularSectionProps) => {
  const localiseString = useLocaliseString()
  if (!articles.length) return null

  return (
    <Box
      as='section'
      display='flex'
      justifyContent='center'
      paddingY='32'
      className='bg-blog-home-popular-section w-full border'
    >
      <SectionWrapper asSection={false}>
        <Stack space='16'>
          <h2 className='text-[21px] font-extended'>
            {localiseString('popularArticlesHeading')}
          </h2>
          <Box display='flex' gap='16' className='flex-col lg:flex-row'>
            {articles[0] && (
              <Box className='basis-3/5'>
                <PopularSectionHero article={articles[0]} />
              </Box>
            )}
            <Box className='basis-2/5 hidden lg:block'>
              <Box display='flex' flexDirection='column' gap='16'>
                {articles.slice(1).map((article, index) => (
                  <SmallArticleCard
                    key={index}
                    article={article}
                    imageFirst={false}
                  />
                ))}
              </Box>
            </Box>
            <Box className='hidden sm:block lg:hidden'>
              <Box display='flex' flexDirection='row' gap='16'>
                {articles.slice(1).map((article, index) => (
                  <Box key={index} className='w-1/4'>
                    <SmallArticleCard article={article} isPortrait />
                  </Box>
                ))}
              </Box>
            </Box>
            <Box className='block sm:hidden'>
              <Box display='flex' flexDirection='column' gap='16'>
                {articles.slice(1).map((article, index) => (
                  <SmallArticleCard key={index} article={article} noImage />
                ))}
              </Box>
            </Box>
          </Box>
        </Stack>
      </SectionWrapper>
    </Box>
  )
}
